import React from "react";

const LigStepElement = ({ currentStep, className, clickHandler }) => {
  return (
    <span className={className} onClick={clickHandler}>
      {currentStep}
    </span>
  );
};

export default LigStepElement;
